import request from '@/utils/request'

// 获取广告列表
export function getAdvertList(params) {
  return request({
    url: '/advertList',
    method: 'get',
    params
  })
}

// 获取产品列表
export function getProductList(params) {
  return request({
    url: '/productList',
    method: 'get',
    params
  })
}

// 获取产品详情
export function getProductDetail(id) {
  return request({
    url: '/productDetail',
    method: 'post',
    params: { id }
  })
}

// 获取新闻列表
export function getNewsList(params) {
  return request({
    url: '/newsList',
    method: 'post',
    data: params
  })
}

// 获取新闻详情
export function getNewsDetail(id) {
  return request({
    url: '/newsDetail',
    method: 'post',
    params: { id }
  })
}

// 获取招聘信息
export function getHrInfo() {
  return request({
    url: '/hrList',
    method: 'post'
  })
}

// 提交联系信息
export function submitContact(data) {
  return request({
    url: '/addContact',
    method: 'post',
    data
  })
}

// 获取关于我们信息
export function getUsInfo(params) {
  return request({
    url: '/getUs',
    method: 'post',
    data: params
  })
}

// 获取SEO信息
export function getSeoInfo(params) {
  return request({
    url: '/getSeo',
    method: 'post',
    data: params
  })
}

// 流式输出接口 - SSE
export function getStreamOutput(message) {
  return new EventSource(`${process.env.NODE_ENV === 'development' ? 'http://localhost:7999/api' : '/api'}/stream/output?message=${encodeURIComponent(message)}`)
}

// 流式文本输出接口
export function getStreamText(message) {
  return fetch(`${process.env.NODE_ENV === 'development' ? 'http://localhost:7999/api' : '/api'}/stream/text?content=${encodeURIComponent(message)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'text/plain;charset=UTF-8'
    }
  })
}

// Dify AI 流式对话接口
export function difyChat(data) {
  const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:7999/api' : '/api'
  
  return fetch(`${baseURL}/stream/dify-chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}
